export type FeedbackApp = 'web' | 'mobile' | 'desktop';

export interface FeedbackReport {
  app: FeedbackApp;
  /** The build the tester is on: a release version, or the short commit for the web. */
  version: string;
  /** OS and runtime as the app sees them: a user agent, "ios 18.6", "darwin 25.6.0 arm64". */
  platform: string;
  /** The signed-in handle; left out when there is none. */
  handle?: string | null;
}

/**
 * The hosted feedback form with the report's identity appended as query
 * parameters the form pre-fills: `app`, `version`, `platform` and, when signed
 * in, `handle`; a `handle` already on the form is dropped for a signed-out
 * report. Null unless the deployment names a well-formed http(s) form, so every
 * surface hides its entry rather than linking to nothing or to a script.
 */
export function feedbackUrl(form: unknown, report: FeedbackReport) {
  if (typeof form !== 'string' || form.trim() === '') return null;
  let url: URL;
  try {
    url = new URL(form.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  url.searchParams.set('app', report.app);
  url.searchParams.set('version', report.version);
  url.searchParams.set('platform', report.platform);
  if (report.handle) url.searchParams.set('handle', report.handle);
  else url.searchParams.delete('handle');
  return url.toString();
}
